module.exports = __webpack_public_path__ + "static/media/HU.07e388a5.png";